"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMailActionType = exports.GoogleSheetActionType = void 0;
var GoogleSheetActionType;
(function (GoogleSheetActionType) {
    GoogleSheetActionType["AddRow"] = "google-sheet-add-row";
    GoogleSheetActionType["AddManyRows"] = "google-sheet-add-many-rows";
    GoogleSheetActionType["UpdateRow"] = "google-sheet-update-row";
    GoogleSheetActionType["SearchRows"] = "google-sheet-search-rows";
    GoogleSheetActionType["GetRows"] = "google-sheet-get-rows";
})(GoogleSheetActionType || (exports.GoogleSheetActionType = GoogleSheetActionType = {}));
var GoogleMailActionType;
(function (GoogleMailActionType) {
    GoogleMailActionType["SendEmail"] = "google-mail-send-email";
    GoogleMailActionType["SearchEmails"] = "google-mail-search-emails";
    GoogleMailActionType["GetEmailContents"] = "google-mail-get-email-contents";
})(GoogleMailActionType || (exports.GoogleMailActionType = GoogleMailActionType = {}));
//# sourceMappingURL=google.js.map